import { EntityId } from "@jackfruit/common"
import { createContext, useContext } from "react"
import { CloudProviderType } from "../CloudProviderTypes"

interface CloudProviderState {
  currentCloudProvider: CloudProviderType
  setCurrentCloudProvider: (provider: CloudProviderType) => void
  isImportingImages: boolean
  setIsImportingImages: (isImporting: boolean) => void
  isCloudProviderModalOpen: boolean
  closeCloudProviderModal: () => void
  openCloudProviderModal: () => void
  lineItemId: EntityId | null
  imageRegionId: EntityId | null
  setLineItemId: (id: EntityId | null) => void
  setImageRegionId: (id: EntityId | null) => void
}

export const CloudProviderContext = createContext<CloudProviderState>({
  currentCloudProvider: "your-device",
  setCurrentCloudProvider: (_provider: CloudProviderType) => {},
  isImportingImages: false,
  setIsImportingImages: (_isImporting: boolean) => {},
  isCloudProviderModalOpen: false,
  closeCloudProviderModal: () => {},
  openCloudProviderModal: () => {},
  imageRegionId: null,
  lineItemId: null,
  setImageRegionId: (_id: EntityId | null) => {},
  setLineItemId: (_id: EntityId | null) => {},
})

export const useCloudProviderContext = () => {
  return useContext(CloudProviderContext)
}
